import type { Router, RouteRecordRaw } from 'vue-router'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: 'create-order/:uid',
  name: PageName.CREATED_ORDER,
  component: () => import('./pages/CreateOrderIndex.vue'),
  meta: {
    breadcrumbName: 'Создание заказа',
  },
  children: [],
}

export default (router: Router) => {
  router.addRoute(PageName.MAIN_LAYOUT, moduleRoute)
}
